import COUNTRIES_LIST from "../../../data/countriesList.json";
export const buildE164 = (phone: string, countryCode: string): string => {
  const digits = phone.replace(/\D/g, "");
  const dialCode = COUNTRIES_LIST.find((c) => c.code === countryCode)?.dialCode ?? "+1";
  return `${dialCode}${digits}`;
};
